<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-transfer :theme="$otTheme" :list="list" v-model="transferSelectItems"
                :labels="[ 'Source', 'Target' ]" top>
            </ot-transfer>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            transferSelectItems: [],
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-transfer%20%3Alist%3D%22list%22%20v-model%3D%22transferSelectItems%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Alabels%3D%22%5B%20'Source'%2C%20'Target'%20%5D%22%20top%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-transfer%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20transferSelectItems%3A%20%5B%5D%2C%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%20%20%20%20computed%3A%20%7B%0A%20%20%20%20%20%20%20%20list()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20const%20list%20%3D%20%5B%5D%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20for%20(let%20i%20%3D%200%3B%20i%20%3C%2010%3B%20i%2B%2B)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20list.push(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20name%3A%20%60name_%24%7Bi%7D%60%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20value%3A%20%60value_%24%7Bi%7D%60%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20return%20list%3B%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
    computed: {
        list() {
            const list = [];
            for (let i = 0; i < 10; i++) {
                list.push({
                    name: `name_${i}`,
                    value: `value_${i}`,
                });
            }
            return list;
        },
    },
};
</script>
